export default "__VITE_ASSET__BBCLZitt__"